import './styles.css';

import React from 'react';
import {
    GeckoModal,
    GeckoModalService,
    GeckoIcon
} from '@geckolabs/gecko-react-ui';
import RSVP_CONSTS from '../../../../constants';
import Card from '../../../Card';
import SessionSingle from '../../../SessionSingle';
import DateUtils from '../../../../services/DateUtils';
import {__, STR_KEY} from '../../../../services/Translate';

const prepareSessionItem = (session, event) => {
    const sessionTime = session.time;
    const attendance  = session.attendance;
    return {
        title: session.title,
        dateStr: !DateUtils.isSameDay(event.start_datetime, event.end_datetime) ? DateUtils.renderStartDateEndDate(sessionTime.start_datetime, sessionTime.end_datetime) : null,
        timeStr: DateUtils.renderStartTimeEndTime(sessionTime.start_datetime, sessionTime.end_datetime, __(STR_KEY.MISC_UNTIL)),
        statusStr: __(`status.${attendance.status}`),
        statusIcon: RSVP_CONSTS.ATTENDANCE.ICONS[attendance.status],
        handler: openSessionModal.bind(this, session.id, event)
    };
}

const openSessionModal = (id, event) => {
    return new GeckoModalService().open(()=>{
        return (
            <GeckoModal className="modal-session-single" >
                <SessionSingle id={id} event={event} />
            </GeckoModal>
        );
    });
};

const PastSessionList = ({sessions = [], event}) => {

    if (Boolean(sessions && sessions.length === 0)) return null;

    return (
        <div className="past-session-list-container">
            <Card>
                <h2>{__(STR_KEY.SESSIONS_LIST_PAST_SESSIONS)}</h2>
                <div className="past-session-list">
                    {sessions.map(session => prepareSessionItem(session, event)).map((session, i) => <PastSessionItem key={i} {...session} />)}
                </div>
            </Card>
        </div>
    );
}

const PastSessionItem = (item) => {
    return (
        <div className="past-session-item" onClick={item.handler}>
            <h3 className="past-session-item-title">{item.title}</h3>
            <div className="past-session-item-datetime">
                <PastSessionItemDateTime {...item} />
            </div>
            <RenderInfoBtn />
            <PastSessionItemStatus {...item} />
        </div>
    );
};

const PastSessionItemDateTime = (item) => {
    return (
        <>
            {item.dateStr ? (
                <div className="past-session-item-date">
                    <GeckoIcon icon={'calendar-alt'} />
                    &nbsp;
                    {item.dateStr}
                </div>
            ) : null}
            <div className="past-session-item-time">
                <GeckoIcon icon={'clock'} />
                &nbsp;
                {item.timeStr}
            </div>
        </>
    );
};

const PastSessionItemStatus = (item) => {
    return (
        <div className="past-session-item-status">
            <GeckoIcon icon={item.statusIcon} />
            &nbsp;
            {item.statusStr}
        </div>
    );
};

const RenderInfoBtn = () => {
    return (
        <div className="past-session-info-details">
            <GeckoIcon icon={'info-circle'} />
            &nbsp;
            <span className="past-session-info-details-span" tabIndex={0} role='button'>
                {__(STR_KEY.SESSIONS_LIST_VIEW_INFO)}
            </span>
        </div>
    );
}

export default PastSessionList;